<template>
  <roe-error-message :field="design.auto_increase_available">
    <v-select
      v-model="design.$model.auto_increase_available"
      name="auto_increase_available"
      :options="selectOptions.auto_increase_available"
      :reduce="label => label.code"
      @input="onChange"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import {
  AutoIncreaseMixin,
  ResetDesignAttributesMixin
} from "@/components/_shared/inputs/design/_mixins";
import { mapGetters } from "vuex";
export default {
  name: "RoeAutoIncreaseSelect",
  components: { RoeErrorMessage },
  mixins: [AutoIncreaseMixin, ResetDesignAttributesMixin],
  props: {
    design: Object
  },
  computed: {
    ...mapGetters(["selectOptions"])
  },
  methods: {
    onChange() {
      this.resetAttributes(this.design, "auto_increase_available");
    }
  }
};
</script>
